<template class="form-dados-cadastrais">
  <div class="wrapper">
    <v-form ref="formDadosCadastrais" @submit.prevent v-model="validDadosCadastrais">
      <v-container class="pt-0">
        <div class="header-step">
          <h3>Dados Cadastrais</h3>
          <p>Informe os dados cadastrais do segurado.</p>
        </div>
        <v-layout row wrap>
          <v-flex
            xs12
            md4
          >
            <v-select
              label="Modalidade de Atuação"
              :items="tipoCliente"
              :disabled="disableCamposDadosCadastrais"
              item-text="descricao"
              item-value="id"
              :rules="regras.notNull"
              return-object
              v-model="dadosCadastrais.transportadora.tipoCliente"
            ></v-select>
          </v-flex>

        </v-layout>
        <v-layout row wrap>
          <v-flex
            xs12
            md4
          >
            <v-text-field
              :disabled="disableCamposDadosCadastrais"
              v-model="dadosCadastrais.razaoSocial"
              label = "Razão Social"
              type = "text"
              :rules="regras.notNull"
              required
            ></v-text-field>

          </v-flex>
          <v-flex
            xs12
            md4
            class="pr-0"
          >
            <v-text-field
              :disabled="disableCamposDadosCadastrais"
              v-model = "dadosCadastrais.transportadora.cnpj"
              label = "CNPJ da empresa"
              mask= "NN.NNN.NNN/NNNN-##"
              :rules="
                formRulesComputed.transportadora.cnpj(
                  dadosCadastrais.transportadora.cnpj
                )
              "
              @blur="verificaCNPJ"
              required
              type = "text"
            ></v-text-field>
          </v-flex>
        </v-layout>
        <v-layout row wrap>
          <v-flex
            xs12
            md3
          >
            <v-btn  color="secondary" @click="dialogAdicionar()" :disabled="disableCamposDadosCadastrais">
              Adicionar contato
            </v-btn>
          </v-flex>
        </v-layout>
        <v-layout row>
          <v-flex
            xs12
            md12
          >
            <v-data-table
              :headers="headers"
              :items="dadosCadastrais.contantoInfo"
              class="elevation-1"
              hide-actions
            >
              <template v-slot:items="props">
                <td ><span v-for="item in props.item.idCategoriaContato" :key="item">{{ buscarTitulo( item,categoriaContato  ) }} {{ props.item.idCategoriaContato.length > 1 ? ", " : ""}}</span></td>
                <td class="text-xs-left">{{ props.item.nome }}</td>
                <td class="text-xs-left">{{ props.item.ddd + props.item.telefone }}</td>
                <td class="text-xs-left">{{ props.item.email }}</td>
                <td class="justify-center layout px-0">
                  <v-icon
                    :disabled="disableCamposDadosCadastrais"
                    small
                    class="mr-2"
                    @click="editItem(props.item)"
                  >
                    edit
                  </v-icon>
                  <v-icon
                    :disabled="disableCamposDadosCadastrais"
                    small
                    @click="deleteItem(props.item)"
                  >
                    delete
                  </v-icon>
                </td>
              </template>
              <template v-slot:no-data>
                <div></div>
              </template>
            </v-data-table>
          </v-flex>
        </v-layout>
        <v-layout row>
          <v-flex
            xs12
            md2
          >
            <v-btn :disabled="!(validDadosCadastrais && dadosCadastrais.contantoInfo.length > 0)" @click="sendDatatoParent" type="submit" color="primary">
              Próximo
            </v-btn>
          </v-flex>
          <v-flex
            xs12
            md4
          >
          </v-flex>

        </v-layout>
      </v-container>

      <v-snackbar
        :timeout="3000"
        :color="snackbar.sucesso ? 'success' : 'error'"
        multi-line
        v-model="snackbar.visivel"
      >
        {{ snackbar.mensagem }}
        <v-btn dark flat @click.native="snackbar.visivel = false">Fechar</v-btn>
      </v-snackbar>
    </v-form>
     <v-dialog
        v-model="dialogContato"
        persistent
        width="600"
      >
      <v-form ref="formContato" v-model="validDadosContato">
        <v-card >
          <v-toolbar card class="toolbar-custom" >
            <v-card-title class="title-dialog-custom">
              Adicionar contato
            </v-card-title>
          </v-toolbar>
          <v-container class="container-special" grid-list-md>
            <v-layout row wrap>
              <v-flex
                xs12
                md12
              >
                <v-text-field
                  v-model="usuario.nome"
                  :rules="regras.notNull"
                  required
                  label="Nome"
                ></v-text-field>
              </v-flex>
              <v-flex
                xs4
                md2
              >
                <v-text-field
                  v-model="usuario.ddd"
                  label="DDD"
                  required
                  :rules="
                  formRulesComputed.telefone.ddd(
                    usuario.ddd,
                    true
                  )
                  "
                  validate-on-blur
                  mask="##"
                ></v-text-field>
              </v-flex>
              <v-flex
                xs8
                md10
              >
                <v-text-field
                  v-model="usuario.telefone"
                  label="Telefone"
                  :rules="
                  formRulesComputed.telefone.numero(
                    usuario.telefone,
                    true
                  )
                "
                  required
                  validate-on-blur
                  mask="#####-####"
                ></v-text-field>
              </v-flex>
              <v-flex
                xs12
                md12
              >
                <v-text-field
                  v-model="usuario.email"
                  ref="usuarioEmail"
                  required
                  @blur="validaEmail()"
                  :rules="
                formRulesComputed.usuario.email(
                  usuario.email,
                  emailEmUso
                )
              "
                  validate-on-blur
                  label="Email"
                ></v-text-field>
              </v-flex>
              <v-flex
                xs12
                md12
              >
                <v-checkbox v-model="confirmar">
                  <span slot="label" class="black--text">Autorizo que meus dados coletados sejam utilizados para receber
                informações e ofertas de soluções do Grupo APISUL. Caso queira saber mais, acesse a nossa
                <a
                  href="https://dpo.privacytools.com.br/policy-view/ZDMVYJzDq/1/política-de%C2%A0privacidade/pt_BR?s=1625162854301 "
                  >Política de Privacidade.</a
                ></span>
                </v-checkbox>
              </v-flex>
            </v-layout>
            <v-layout row>

              <v-flex
                xs12
                md4
              >
                <v-btn flat color="primary" @click="dialogContato = false">Cancelar</v-btn>
              </v-flex>
              <v-flex
                xs12
                offset-md4
                md4
              >
                <v-btn :disabled="!formValid" class="primary" @click="salvarContatosList">Salvar</v-btn>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card>
      </v-form>
      </v-dialog>
      <v-dialog
        v-model="dialogEditDadosCadastrais"
        persistent
        width="350"
      >
        <v-form  v-model="validDadosContato">
          <v-card >
            <v-toolbar card class="toolbar-custom" >
              <v-card-title class="title-dialog-custom">
                Adicionar contato
              </v-card-title>
            </v-toolbar>
            <v-container class="container-special" grid-list-md>
              <v-layout row wrap>

                <v-flex
                  x12
                  md12
                >
                  <v-text-field
                    v-model="contatoEdit.nome"
                    :rules="regras.notNull"
                    required
                    label="Nome"
                  ></v-text-field>
                </v-flex>
                <v-flex
                  xs4
                  md2
                >
                  <v-text-field
                    v-model="contatoEdit.ddd"
                    label="DDD"
                    required
                    :rules="
                formRulesComputed.telefone.ddd(
                  contatoEdit.ddd,
                  true
                )
              "
                    mask="##"
                  ></v-text-field>
                </v-flex>
                <v-flex
                  xs8
                  md10
                >
                  <v-text-field
                    v-model="contatoEdit.telefone"
                    label="Telefone"
                    required
                    :rules="
                formRulesComputed.telefone.numero(
                  contatoEdit.telefone,
                  true
                )
              "
                    mask="#####-####"
                  ></v-text-field>
                </v-flex>
                <v-flex
                  xs12
                  md12
                >
                  <v-text-field
                    v-model="contatoEdit.email"
                    required
                    :rules="regras.notNull"
                    label="Email"
                  ></v-text-field>
                </v-flex>
              </v-layout>
              <v-layout row>

                <v-flex
                  xs12
                  md4
                >
                  <v-btn flat color="primary" @click="closeEditContato">Cancelar</v-btn>
                </v-flex>
                <v-flex
                  xs12
                  offset-md4
                  md4
                >
                  <v-btn :disabled="!formValid" type="submit" class="primary" @click="saveEditContato">Salvar</v-btn>
                </v-flex>
              </v-layout>
            </v-container>
          </v-card>
        </v-form>
      </v-dialog>
  </div>
</template>

<script>
import axios from "axios";
import formRules from "@/helpers/form-rules";
import perfil from "@/helpers/perfil";
import usuarioHelper from "@/helpers/usuario-logado";
import validadores from "@/helpers/validadores";
export default {
  name : "QARDadosCadastrais",
  props: {
    protocolo: String,
    dadosQuestionario: {
      type: Object,
      required: false
    }
  },
  data : () => ({
    tipoCliente: [],
    confirmar: false,
    validDadosCadastrais: true,
    validDadosContato:  true,
    dialogContato: false,
    dialogEditDadosCadastrais: false,
    editedIndex: -1,
    emailEmUso: false,
    dadosCadastrais : {
      idUsuarioSolicitante: null,
      idModalidadeAtuacao : null,
      razaoSocial : null,
      contantoInfo: [],
      transportadora : {
        tipoCliente: null,
        cnpj : "",
      }
    },
    usuario: {
      id: 0,
      nome: null,
      ddd: null,
      telefone: null,
      email: "",
    },
    contatoEdit: {
      nome: null,
      ddd: null,
      telefone: null,
      email: null
    },

    defaultItem: {
      nome: null,
      ddd: null,
      telefone: null,
      email: null
    },
    modalideAtuacao : [
      { id: 1, titulo: "Embarcador" },
      { id: 2, titulo: "Transportador" },
      { id: 3, titulo: "Outra" },
    ],
    categoriaContato : [
      { id: 1, titulo: "Empresa" },
      { id: 2, titulo: "Responsável" },
      { id: 3, titulo: "Proprietário" }
    ],
    headers: [
      { text: "Tipo do contato", value:"idCategoriaContato" },
      { text: "Nome", value: "nome" },
      { text: "Telefone", value: "telefone" },
      { text: "Email", value: "email" },
      { text: "Ações", value: "actions", sortable: false }
    ],
    regras: {
      notNull: [v => !!v || "Você não pode deixar este campo em branco"],
      cnpj: [v => !!String(v).match(/^[A-Za-z0-9]{12}\d{2}$/) || "Valor incorreto"],
    },
    snackbar: {
      visivel: false,
      sucesso: false,
      mensagem: ""
    },

  }),

  computed: {
    disableCamposDadosCadastrais() {
      return this.protocolo != null || this.dadosQuestionario.id != null;
    },
    formRulesComputed: function () {
      return formRules;
    },
    formValid: function() {
      const self = this
      if (self.validDadosContato == true && self.confirmar == true) {
        return true;
      } else {
        return false;
      }
    }
  },
  mounted() {
    this.buscaTipoCliente();
  },
  watch: {
    dadosQuestionario(val) {
      if(val.id != null && val.id !=undefined) {
        this.buscarTransportadora(val.idTransportadora);
        this.buscarUsuario(val.idUsuarioSolicitante);
        this.buscarUsuarioAutor(val.idUsuarioAutor);
        this.$emit('dadosEnviados', true);
      }
    }
  },
  methods: {
    buscaTipoCliente() {
      axios.get(`${process.env.URL_TRANSPORTADORAMS}/v1/buscaTipoCliente`, {
          headers: {
              'Authorization': `Bearer ${usuarioHelper.USUARIO_LOGADO().token}`
          }
      })
      .then(res => {
        if(res.data) {
          this.tipoCliente = res.data;
        }
      })
    },
    buscarUsuarioAutor(val) {
      axios.get(`${process.env.URL_USUARIOMS}/v1/buscaUsuarioSimplesPorId?id=${val}`, {
          headers: {
              'Authorization': `Bearer ${usuarioHelper.USUARIO_LOGADO().token}`
          }
      }).then(res => {
        if(res.data) {

         this.$emit('nomeUsuarioAutor', res.data.nome);
        }
      })
    },
    buscarUsuario(val) {
      axios.get(`${process.env.URL_USUARIOMS}/v1/buscaUsuarioSimplesPorId?id=${val}`, {
          headers: {
              'Authorization': `Bearer ${usuarioHelper.USUARIO_LOGADO().token}`
          }
      }).then(res => {
        if(res.data) {

          this.usuario.email = res.data.email;
          this.usuario.nome = res.data.nome;
          this.usuario.ddd = res.data.telefones[0].ddd;
          this.usuario.telefone = res.data.telefones[0].telefone;
          this.dadosCadastrais.contantoInfo.push(this.usuario);
        }
      })
    },
    buscarTransportadora(val) {
      axios.get(`${process.env.URL_TRANSPORTADORAMS}/v1/buscaTransportadora?id=${val}`, {
          headers: {
              'Authorization': `Bearer ${usuarioHelper.USUARIO_LOGADO().token}`
          }
      }).then(res => {
        if(res.data) {
          this.dadosCadastrais.razaoSocial = res.data.nome;
          this.dadosCadastrais.transportadora.cnpj = res.data.cnpj;
          this.dadosCadastrais.transportadora.tipoCliente = res.data.tipoCliente;
          this.$emit('razaoSocialTrasnportadora',  res.data.nome);
          this.$emit('dadosTransportadoroBusca',  res.data);

        }
      })

    },
    dialogAdicionar() {
      this.$refs.formContato.reset()
      this.dialogContato = true
    },
    salvarContatosList() {
      var contato = { ...this.usuario };
      this.dadosCadastrais.contantoInfo.push(contato);
      return axios.post(
        `${process.env.URL_USUARIOMS}/v1/no-auth/insereOuAtualizaCliente`,
        {
          email: this.usuario.email,
          nome: this.usuario.nome,
          ativo: true,
          telefones: [
              {
                ddd: this.usuario.ddd,
                telefone: this.usuario.telefone,
              },
            ],
            perfil: null,
        }
      ).then(res => {
        this.dadosCadastrais.idUsuarioSolicitante = res.data.id;
        this.dialogContato = false;
        this.snackbar.visivel = true;
        this.snackbar.sucesso = true;
        this.snackbar.mensagem = "Dados de contato salvo.";

        this.resetForm();
      })
    },
    resetForm() {
      this.usuario.nome = "";
      this.usuario.ddd = "";
      this.usuario.telefone = "";
      this.usuario.email = "";
    },
    sendDatatoParent() {
      this.$emit('dadosCadastrais', this.dadosCadastrais);
    },
    buscarTitulo(entity, list) {
      if (entity) {
        const campo = list.find(
          (item) => entity
        );
        if (campo) {
          return campo.titulo;
        }
      }
      return "-";
    },

    editItem (item) {
      this.editedIndex = this.dadosCadastrais.contantoInfo.indexOf(item)
      this.contatoEdit = Object.assign({}, item)
      this.dialogEditDadosCadastrais = true
    },
    deleteItem (item) {
      const index = this.dadosCadastrais.contantoInfo.indexOf(item)
      confirm('Deseja deletar este contato?') && this.dadosCadastrais.contantoInfo.splice(index, 1)
    },
    closeEditContato () {
      this.dialogEditDadosCadastrais = false
      setTimeout(() => {
        this.contatoEdit = Object.assign({}, this.defaultItem)
        this.editedIndex = -1
      }, 300)
    },

    verificaCNPJ: function () {
      const self = this;
      self.countCarregamentosCidade = 0;
      validadores.validarCNPJ(self.dadosCadastrais.transportadora.cnpj.trim())
    },
    saveEditContato () {
      var contato = { ...this.contatoEdit };
      if (this.editedIndex > -1) {
        Object.assign(this.dadosCadastrais.contantoInfo[this.editedIndex], this.contatoEdit)
      } else {
        this.dadosCadastrais.contantoInfo.push(contato)
      }
      this.close()
    },
    validateFields() {
      if(
        this.dadosCadastrais.idModalidadeAtuacao.length &&
        this.dadosCadastrais.cnpj.length &&
        this.dadosCadastrais.razaoSocial.length
      ) {
        this.disableSubmitDadosCadastrais = true;
      }
    },
    validaEmail: function () {
      const self = this;
      axios
        .get(
          `${process.env.URL_USUARIOMS}/v1/no-auth/verificaEmailCadastrado?email=${self.usuario.email}`
        )
        .then((response) => {
          self.emailEmUso = response.data;

          if (self.emailEmUso && usuarioHelper.USUARIO_LOGADO()) {
            self.buscaUsuario();
          } else if (self.emailEmUso) {
            self.verificaUsuario();
          }
        })
        .catch((erro) => {
          self.$store.commit("endLoading");
          self.snackbar.visivel = true;
          self.snackbar.sucesso = false;
          self.snackbar.mensagem = "Ocorreu um erro ao validar o e-mail";
        });
    },
    buscaUsuario: function () {
      const self = this;
      if (
        !self.$refs.usuarioEmail.error ||
        usuarioHelper.USUARIO_LOGADO().perfil.id == perfil.COMERCIAL
      ) {
        axios
          .get(
            `${process.env.URL_USUARIOMS}/v1/buscaUsuarioPorEmail?email=${
              self.usuario.email
            }&token=${usuarioHelper.USUARIO_LOGADO().token}`,
            {
              headers: {
                Authorization: `Bearer ${usuarioHelper.USUARIO_LOGADO().token}`,
              },
            }
          )
          .then((response) => {
            const data = response.data;
            if (data) {
              self.usuario.id = data.id;
              self.usuario.nome = data.nome;
              self.usuario.ddd =
                data.telefones[0].ddd != 0 ? `${data.telefones[0].ddd}` : "";
              self.usuario.telefone =
                data.telefones[0].telefone;
              self.emailEmUso = false;
            }
          })
          .catch((erro) => {
            self.emailEmUso = true;
            self.snackbar.mensagem = erro.response.data.message;
            self.snackbar.sucesso = false;
            self.snackbar.visivel = true;
          });
      }
    },
    verificaUsuario: function () {
      const self = this;
      axios
        .get(
          `${process.env.URL_USUARIOMS}/v1/no-auth/verificaUsuarioCadastrado?email=${self.usuario.email}`
        )
        .then((response) => {
          if (response.data) {
            self.modalUsuarioCadastrado = true;
          } else {
            self.emailEmUso = false;
          }
        });
    }
  }
}
</script>

<style>
.QuestionarioAnaliseRiscos .title-dialog-custom {
  color: #00456e;
  font-weight: bold;
  padding-bottom: 0;
  font-size: 18px;
}
.QuestionarioAnaliseRiscos .toolbar-custom {
  background-color: transparent;
}
.QuestionarioAnaliseRiscos .container-special {
  padding: 0 40px 40px 40px;
}
.QuestionarioAnaliseRiscos .wrapper{
  margin-top: 32px;
}

</style>



// WEBPACK FOOTER //
// src/components/pages/questionario-analise-riscos/steps/QARDadosCadastrais.vue